import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {AvisEnum, ResponseAvis, ResponseAvisRequest} from './response-avis.model';
import {Observable} from 'rxjs';


@Injectable({providedIn: 'root'})
export class ResponseAvisService extends DaoGeneric<ResponseAvis> {
  private _api = `${environment.baseUrl}/demat/responseavis/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp: string | undefined): string {
    return this._api;
  }

  requestOrRemindOpinion(avis: ResponseAvisRequest, message: string = ''): Observable<any> {
    const _url = `${this._api}request_or_remind_opinion/`;
    const _requestOpinion = avis;
    if (message) {
      _requestOpinion.message = message;
    }
    return this.httpClient.post(_url, _requestOpinion);
  }

  opinionRequested() {
    const url = `${this._api}opinion_requested`;
    return this.httpClient.get<boolean>(url);
  }

  myOpinionExterne(uuid: string) {
    const url = `${this._api}my_opinion_externe/${uuid}`;
    return this.httpClient.get<ResponseAvis>(url);
  }

  labelAvis(avisEnum: AvisEnum) {
    return AvisEnum.toString(avisEnum);
  }

  classAvis(avisEnum: AvisEnum) {
    return AvisEnum.toClass(avisEnum);
  }
  getChipAvis(avis: ResponseAvis) {
    const stateLabel = this.labelAvis(avis.avis);
    const classType = this.classAvis(avis.avis);
    return `<small><span class="state-demat-avis-chip ${classType}">${stateLabel}</span></small>`;
  }
}
